module.exports = __webpack_public_path__ + "static/media/ws.155d3921.png";